import { z } from "zod";

/* ---------------- PRODUCT USAGE RATE ---------------- */

export const productUsageRateSchema = z.object({
  productId: z.number(),
  productName: z.string(),
  totalTransactions: z.number(),
  marketShare: z.number(),
});

export const productUsageRateListSchema = z.array(productUsageRateSchema);
export type ProductUsageRateSchema = z.infer<typeof productUsageRateSchema>;

/* ---------------- DASHBOARD PRODUCT USAGE RATE COUNT ---------------- */

export const dashboardCountsSchema = z.object({
  hihVisitCount: z.number(),
  konsultaSubmittedCount: z.number(),
});

export type DashboardCountsSchema = z.infer<
  typeof dashboardCountsSchema
>;


/* ---------------- SUBSCRIPTIONS PER PRODUCT ---------------- */

export const subscriptionsPerProductSchema = z.object({
  productId: z.number(),
  productName: z.string(),
  facilities: z.number(),
  clients: z.number(),
  iconUrl: z.string().nullable().optional(),
});

export const subscriptionsPerProductListSchema = z.array(
  subscriptionsPerProductSchema,
);

export type SubscriptionsPerProductSchema = z.infer<
  typeof subscriptionsPerProductSchema
>;

/* ---------------- GEOGRAPHIC DISTRIBUTION ---------------- */

export const productDistributionItemSchema = z.object({
  label: z.string(),
  value: z.number(),
  iconUrl: z.string().nullable().optional(),
});

export const geographicDistributionSchema = z.object({
  rank: z.number(),
  regionName: z.string(),
  facilities: z.number(),
  topProduct: z.string(),
  growthPercentage: z.number().nullable().optional(),
  distribution: z.array(productDistributionItemSchema),
});

export const geographicDistributionListSchema = z.array(
  geographicDistributionSchema,
);

export type GeographicDistributionSchema = z.infer<
  typeof geographicDistributionSchema
>;


export const azureMapPerCitySchema = z.object({
  cityName: z.string(),
  totalValues: z.number(),
  distribution: z.array(
    z.object({
      label: z.string(),
      value: z.number(),
      iconUrl: z.string().nullable().optional(),
    }),
  ),
});

export const azureMapPerCityListSchema = z.array(azureMapPerCitySchema);

export type AzureMapPerCitySchema = z.infer<
  typeof azureMapPerCitySchema
>;